// Speech Recognition Component 
Accepts message as props and getVoiceMessage as a function

<template>
    <div v-bind:class="isRecording ? 'mic_on' : ''" class="mic" v-if="showMic" v-on:click="toggleRecording(isRecording)">  
      <img src="../../assets/mic.svg">
    </div>
</template>

<script>
export default {
  props: ['message'],
  data () {
    return {
      showMic: true,
      isRecording: false,
      recognizer: null,
      finalTranscript: ''
    }
  },
  watch: {
    message: function (newVal, oldVal) {
      if (newVal === '') {
        this.finalTranscript = ''
      }
    }
  },
  mounted () {
    this.initializeSpeechRecognition()
  },
  methods: {
    initializeSpeechRecognition: function () {
      let vm = this
      var firstInterim = false
      window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || null
      if (window.SpeechRecognition === null) {
        vm.showMic = false
        console.log("Browser doesn't suport speech recognition")
      } else {
        vm.recognizer = new window.SpeechRecognition()
        vm.recognizer.continuous = true
        // Start recognising
        vm.recognizer.onresult = function (event) {
          var interimTranscript = ''
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              vm.finalTranscript += event.results[i][0].transcript
            } else {
              interimTranscript += event.results[i][0].transcript
            }
          }
          if (interimTranscript === '') {
            firstInterim = true
          }
          vm.finalTranscript = vm.capitalize(vm.finalTranscript)
          vm.finalTranscript = vm.linebreak(vm.finalTranscript)
          interimTranscript = vm.linebreak(interimTranscript)
          vm.$emit('getVoiceMessage', vm.finalTranscript)
          if (firstInterim) {
            interimTranscript = vm.finalTranscript + interimTranscript
          }
          if (interimTranscript !== '') {
            vm.$emit('getVoiceMessage', interimTranscript)
          }
        }
        // Listen for errors
        vm.recognizer.onerror = function (event) {
          console.log('Recognition error(2): ' + event.message)
        }
      }
    },
    linebreak (s) {
      var twoLine = /\n\n/g
      var oneLine = /\n/g
      return s.replace(twoLine, '<p></p>').replace(oneLine, '<br>')
    },
    capitalize (s) {
      if (!s) {
        s = ''
      }
      var firstChar = /\S/
      return s.replace(firstChar, function (m) { return m.toUpperCase() })
    },
    toggleRecording: function (isRecording) {
      let vm = this
      vm.isRecording = isRecording
      vm.finalTranscript = vm.message
      if (vm.isRecording) {
        vm.recognizer.stop()
        vm.isRecording = false
        console.log('Recognition stopped')
      } else {
        try {
          vm.recognizer.start()
          vm.isRecording = true
          console.log('Recognition started')
        } catch (ex) {
          console.log('Recognition error(1): ' + ex.message)
        }
      }
    },
    stopRecording: function (isRecording) {
      this.toggleRecording(isRecording)
    }
  },
  created: function () {
  }
}
</script>

<style lang="scss" scoped>
    .mic_on {
        // height:25px;
        // width:25px;
        border-radius:50%;
        
        -webkit-transition:height .25s ease, width .25s ease;
        transition:height .25s ease, width .25s ease;
        
        -webkit-transform:translate(0%, 0%);
        transform:translate(0%, 0%);
      }
      .mic_on:before,
      .mic_on:after {
        content:'';
        display:block;
        position:absolute;
        top:0; right:0; bottom:0; left:0;
        border-radius:50%;
        border:1px solid red;
      }
      .mic_on:before {
        -webkit-animation: ripple 2s linear infinite;
        animation: ripple 2s linear infinite;
      }
      .mic_on:after {
        -webkit-animation: ripple 2s linear 1s infinite;
        animation: ripple 2s linear 1s infinite;
      }
      @-webkit-keyframes ripple{
        0% {-webkit-transform:scale(1); }
        75% {-webkit-transform:scale(1.75); opacity:1;}
        100% {-webkit-transform:scale(2); opacity:0;}
      }

      @keyframes ripple{
        0% {transform:scale(1); }
        75% {transform:scale(1.75); opacity:1;}
        100% {transform:scale(2); opacity:0;}
      }
</style>



// WEBPACK FOOTER //
// src/components/common/SpeechRecognition.vue